import Loading from './loading';
import { SIZE } from './constants';

export default Loading;
export { SIZE };